export class BarChartDataItem<T> {
    constructor(public label: string, public value: number, public data?: T) {}
}
